import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchSubscriptionPlans } from '../redux/slices/subscriptionPlanSlice';
import { logoutDoctor } from '../redux/slices/authSlice';
import '../styles/Auth.css';

const SubscriptionStatus = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { doctor, subscriptionActive, subscriptionExpiryDate } = useSelector(
    (state) => state.auth,
  );

  useEffect(() => {
    dispatch(fetchSubscriptionPlans());
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(logoutDoctor());
    navigate('/login');
  };

  const handleRenew = () => {
    // This would typically redirect to a payment page or form
    // For now, we'll show an alert
    alert('Please contact admin to renew your subscription');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: '500px' }}>
        <h1 className="auth-title">Subscription Status</h1>
        <p className="auth-subtitle">Welcome, {doctor?.firstName} {doctor?.lastName}</p>

        <div
          style={{
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center',
            backgroundColor: subscriptionActive ? '#f0f8ff' : '#fff5f5',
            border: `2px solid ${subscriptionActive ? '#4CAF50' : '#f44336'}`,
          }}
        >
          <h2 style={{ margin: '0 0 10px 0', color: subscriptionActive ? '#4CAF50' : '#f44336' }}>
            {subscriptionActive ? '✓ Subscription Active' : '✗ Subscription Inactive'}
          </h2>
          {subscriptionExpiryDate && (
            <p style={{ margin: '5px 0', color: '#666', fontSize: '14px' }}>
              Expires on: {formatDate(subscriptionExpiryDate)}
            </p>
          )}
        </div>

        {!subscriptionActive && (
          <div
            style={{
              padding: '16px',
              backgroundColor: '#fef3cd',
              border: '1px solid #ffc107',
              borderRadius: '6px',
              marginBottom: '20px',
              color: '#856404',
            }}
          >
            <p style={{ margin: '0 0 10px 0', fontWeight: '600' }}>
              Your subscription has expired. Please renew to continue using the system.
            </p>
            <p style={{ margin: '0' }}>
              Contact the admin to process a new subscription payment.
            </p>
          </div>
        )}

        {subscriptionActive && (
          <div
            style={{
              padding: '20px',
              marginBottom: '20px',
              backgroundColor: '#f9f9f9',
              borderRadius: '6px',
              border: '1px solid #e0e0e0',
            }}
          >
            <h3 style={{ margin: '0 0 15px 0', fontSize: '16px' }}>Doctor Information</h3>
            <div style={{ fontSize: '14px', color: '#666' }}>
              <p><strong>Email:</strong> {doctor?.email}</p>
              <p><strong>Subscription Expires:</strong> {formatDate(subscriptionExpiryDate)}</p>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
          {subscriptionActive && (
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                flex: 1,
                padding: '12px 24px',
                background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              Go to Dashboard
            </button>
          )}
          {!subscriptionActive && (
            <button
              onClick={handleRenew}
              style={{
                flex: 1,
                padding: '12px 24px',
                background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
            >
              Renew Subscription
            </button>
          )}
          <button
            onClick={handleLogout}
            style={{
              flex: 1,
              padding: '12px 24px',
              background: '#e0e0e0',
              color: '#333',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              fontSize: '14px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
          >
            Logout
          </button>
        </div>

        <div style={{ fontSize: '12px', color: '#999', textAlign: 'center' }}>
          <p>Need help? Contact the admin for subscription renewal</p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionStatus;
